'use client';
import getLocal from '@/app/utils/getLocal';

export default function FooterCookieSettingA() {
    const { locale = 'us' } = getLocal();
    return (
        <>
            {locale === 'us' && (
                <div className="cookies-settings">
                    <a href="javascript:__cmp('showScreenAdvanced')"> Cookies Settings</a>
                </div>
            )}
        </>
    );
}
